import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VerticalAlignCenterIcon(props: IconProps) {
    return <Icon {...props} iconKey={"vertical_align_center"}/>
}
